import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "react-bootstrap";
import PurchaseModuleModal from "../modals/PurchaseModuleModal";
import { validateUserRoleIds } from "../GlobalTools";

const canShowPremiumDropdown = validateUserRoleIds([1, 2]);

const DropdownPremium = (props) => {
  // Destructure props
  const {
    service,
    fromView,
    show = canShowPremiumDropdown,
    children = null,
    ...dropdownProps
  } = props;
  // Hooks
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  const handleClick = useCallback(() => {
    setShowPremiumModal(true);
  }, []);

  return show ? (
    <>
      <Dropdown style={{ display: "inline-block", marginRight: "10px" }}>
        <Dropdown.Toggle {...dropdownProps} onClick={handleClick}>
          <i className="bi bi-download" />
          {children}
          <i className="ms-2 fas fa-crown premiumColor" />
        </Dropdown.Toggle>
      </Dropdown>
      {showPremiumModal && (
        <PurchaseModuleModal
          showModal={showPremiumModal}
          closeModal={() => setShowPremiumModal(false)}
          name={service}
          originView={fromView}
        />
      )}
    </>
  ) : null;
};

DropdownPremium.propTypes = {
  service: PropTypes.string.isRequired,
  fromView: PropTypes.string.isRequired,
  children: PropTypes.node,
  show: PropTypes.bool,
};

export default DropdownPremium;
